module.exports = __webpack_public_path__ + "assets/img/page2-design-base-3ddb84c0.jpg";